
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import { api } from "../../core"
import { type LiveId, type SelectionId, type SpaceKey, FirebaseStoragePaths } from "popopo-msg"
import { UploadToFireStorageInput } from "../UploadToFireStorageInput"
import { useToast } from "popopo-lib-front/hook"

type SelectionParticipantCreateForms = {
  image: boolean
  description?: string
}

export const SelectionParticipantCreateForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId }) => {
  const form = useForm<SelectionParticipantCreateForms>({
    mode: "onBlur",
    defaultValues: {
      image: false,
      description: undefined,
    },
  })
  const toast = useToast()
  const { spaceKey, liveId, selectionId } = props
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SelectionParticipantCreateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/participants", {
        params: {
          path: {
            space_key: spaceKey,
            live_id: liveId,
            selection_id: selectionId,
          },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          image: value.image,
          description: value.description === "" ? undefined : value.description,
        },
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "Participant", message: JSON.stringify(res)})
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "Participant", message: e.toString() })
    }
  }

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <UploadToFireStorageInput
          label="Image"
          uploadPath={`/${FirebaseStoragePaths.SelectionParticipant.getImagePathUploaded(props.firebase.uid, spaceKey, liveId, selectionId)}`}
          onChange={(successfullyUploaded) => {
            form.setValue("image", successfullyUploaded)
          }}
          disabled={isSubmitting}
        />

        <div className="form-floating">
          <input className="form-control" {...form.register("description")} disabled={isSubmitting} />
          <label>Description</label>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Send
        </button>
      </form>
    </>
  )
}
